// extracted by mini-css-extract-plugin
export var avatar = "_qt-3";
export var avatarContainer = "_qt-2";
export var avatarSpacer = "_qt-5";
export var avatarSpacerContainer = "_qt-4";
export var avatarStackContainer = "_qt-1";
export var bubble = "_qt-0";
export var remainderBubble = "_qt-6";